export default __webpack_public_path__ + "62615e35911511d8039c0530bc103012.svg";